import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a9c9c07"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BidsForm" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_4 = { class: "mt-6 px-6 py-4 border bg-white flex flex-col" }
const _hoisted_5 = {
  key: 0,
  class: "cities"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_7 = { class: "w-full flex items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-3 font-bold" }, "Характеристики груза", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-3 font-bold" }, "Данные водителя и т/с", -1))
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { class: "flex items-center justify-between mt-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_14 = {
  key: 0,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Водитель с ИИН не найден!", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ИИН не прошел проверку СБ!", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 2,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Отказано службой безопасности", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Обратитесь в службу безопасности", -1))
const _hoisted_23 = {
  key: 3,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Физ. лицо не прошел проверку службы безопасности", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Обратитесь в службу безопасности", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "w-full mt-2" }
const _hoisted_28 = {
  key: 0,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Отказано службой безопасности", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Обратитесь в службу безопасности", -1))
const _hoisted_31 = {
  key: 1,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Авто не прошло проверку службы безопасности", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Обратитесь в службу безопасности", -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "flex items-center justify-between mt-6" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_file_reader = _resolveComponent("file-reader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Создание заявки" }),
      _createVNode(_component_the_button, {
        class: "second text small",
        disabled: _ctx.state.is_loading,
        onClick: _ctx.emitCancel
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Отмена ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_the_select, {
        placeholder: "Перевозчик",
        loading: _ctx.data_state.carriers.is_loading,
        failed: _ctx.data_state.carriers.is_failed,
        "error-text": "При получении списка перевозчиков произошла ошибка",
        options: _ctx.data_state.carriers.list,
        "is-invalid": _ctx.state_form$.carrierId.$error,
        "validation-errors": _ctx.state_form$.carrierId.$errors,
        value: _ctx.state.carrierId,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.carrierId) = $event)),
        onRefresh: _ctx.loadCarriers,
        onChange: _ctx.onCarrierChange
      }, null, 8, ["loading", "failed", "options", "is-invalid", "validation-errors", "value", "onRefresh", "onChange"]),
      (_ctx.citiesLength)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.cityIds, (city_id, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `city-${idx}`,
                class: "cities__item"
              }, [
                (_ctx.isAddCity(idx))
                  ? (_openBlock(), _createBlock(_component_the_button, {
                      key: 0,
                      class: "primary small my-2",
                      onClick: ($event: any) => (_ctx.addCity(idx))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_the_select, {
                    class: "cities__city",
                    placeholder: _ctx.getCityPlaceholder(idx),
                    loading: _ctx.data_state.cities.is_loading,
                    failed: _ctx.data_state.cities.is_failed,
                    "error-text": "При получении списка городов произошла ошибка",
                    options: _ctx.data_state.cities.list,
                    value: _ctx.state.cityIds[idx],
                    "onUpdate:value": ($event: any) => ((_ctx.state.cityIds[idx]) = $event),
                    "is-invalid": !_ctx.state.cityIds[idx],
                    onRefresh: _ctx.loadCities
                  }, null, 8, ["placeholder", "loading", "failed", "options", "value", "onUpdate:value", "is-invalid", "onRefresh"]),
                  (_ctx.isDelete(idx))
                    ? (_openBlock(), _createBlock(_component_the_button, {
                        key: 0,
                        class: "red small text ml-2 py-3",
                        disabled: _ctx.data_state.cities.is_loading,
                        onClick: ($event: any) => (_ctx.deleteCity(idx))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_the_input, {
        placeholder: "Грузоотправитель",
        value: "ТОО Spark Логистика",
        disabled: "",
        class: "mt-3"
      }),
      _createVNode(_component_the_input, {
        placeholder: "Адрес загрузки",
        "is-invalid": _ctx.state_form$.loadAddress.$error,
        "validation-errors": _ctx.state_form$.loadAddress.$errors,
        value: _ctx.state.loadAddress,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.loadAddress) = $event)),
        class: "mt-2"
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        type: "date",
        placeholder: "Дата загрузки",
        "is-invalid": _ctx.state_form$.dateOfLoad.$error,
        "validation-errors": _ctx.state_form$.dateOfLoad.$errors,
        value: _ctx.state.dateOfLoad,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.dateOfLoad) = $event)),
        class: "mt-2"
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        placeholder: "Контактное лицо, тел.",
        "is-invalid": _ctx.state_form$.senderPerson.$error,
        "validation-errors": _ctx.state_form$.senderPerson.$errors,
        value: _ctx.state.senderPerson,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.senderPerson) = $event)),
        class: "mt-2"
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        disabled: "",
        placeholder: "Грузополучатель",
        value: "ТОО Spark Логистика",
        class: "mt-2"
      }),
      _createVNode(_component_the_input, {
        placeholder: "Адрес разгрузки",
        "is-invalid": _ctx.state_form$.unloadAddress.$error,
        "validation-errors": _ctx.state_form$.unloadAddress.$errors,
        value: _ctx.state.unloadAddress,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.unloadAddress) = $event)),
        class: "mt-2"
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        type: "date",
        placeholder: "Дата разгрузки",
        "is-invalid": _ctx.state_form$.dateOfUnload.$error,
        "validation-errors": _ctx.state_form$.dateOfUnload.$errors,
        value: _ctx.state.dateOfUnload,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.dateOfUnload) = $event)),
        class: "mt-2"
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        placeholder: "Контактное лицо, тел.",
        "is-invalid": _ctx.state_form$.receiverPerson.$error,
        "validation-errors": _ctx.state_form$.receiverPerson.$errors,
        value: _ctx.state.receiverPerson,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.receiverPerson) = $event)),
        class: "mt-2"
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _hoisted_9,
      _createVNode(_component_the_input, {
        placeholder: "Характер груза, вес, объём",
        "is-invalid": _ctx.state_form$.natureOfCargo.$error,
        "validation-errors": _ctx.state_form$.natureOfCargo.$errors,
        value: _ctx.state.natureOfCargo,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.natureOfCargo) = $event)),
        class: "mt-2"
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        placeholder: "Страхование",
        "is-invalid": _ctx.state_form$.insurance.$error,
        "validation-errors": _ctx.state_form$.insurance.$errors,
        value: _ctx.state.insurance,
        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.insurance) = $event)),
        class: "mt-2"
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        placeholder: "Тип кузова",
        "is-invalid": _ctx.state_form$.bodyType.$error,
        "validation-errors": _ctx.state_form$.bodyType.$errors,
        value: _ctx.state.bodyType,
        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.bodyType) = $event)),
        class: "mt-2"
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        placeholder: "Температурный режим",
        "is-invalid": _ctx.state_form$.temperatureRegime.$error,
        "validation-errors": _ctx.state_form$.temperatureRegime.$errors,
        value: _ctx.state.temperatureRegime,
        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.temperatureRegime) = $event)),
        class: "mt-2"
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        placeholder: "Стоимость перевозки",
        "is-invalid": _ctx.state_form$.costOfTransportation.$error,
        "validation-errors": _ctx.state_form$.costOfTransportation.$errors,
        value: _ctx.state.costOfTransportation,
        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.costOfTransportation) = $event)),
        class: "mt-2"
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        placeholder: "Срок и форма оплаты",
        value: _ctx.termAndFormOfPayment,
        disabled: "",
        class: "mt-2"
      }, null, 8, ["value"]),
      _createVNode(_component_checkbox, {
        class: "mt-2",
        value: _ctx.state.isNds,
        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.isNds) = $event)),
        disabled: true,
        label: "С НДС",
        "return-integer": ""
      }, null, 8, ["value"]),
      _hoisted_10,
      _createVNode(_component_the_select, {
        class: "mt-3",
        placeholder: "Водитель",
        "search-without-refresh": "",
        "search-by": "fullName",
        loading: _ctx.data_state.drivers.is_loading,
        failed: _ctx.data_state.drivers.is_failed,
        "error-text": "При получении списка водителей произошла ошибка",
        options: _ctx.data_state.drivers.list,
        disabled: !_ctx.state.carrierId,
        value: _ctx.state.driver_id,
        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.driver_id) = $event)),
        label: "fullName",
        onRefresh: _ctx.loadDrivers,
        onChange: _ctx.onDriverSelect
      }, null, 8, ["loading", "failed", "options", "disabled", "value", "onRefresh", "onChange"]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_the_input, {
            placeholder: "ИИН",
            value: _ctx.state.iin,
            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.iin) = $event)),
            "is-invalid": _ctx.state_form$.iin.$error || _ctx.iin_form$.iin.$error,
            "validation-errors": _ctx.state_form$.iin.$errors || _ctx.iin_form$.iin.$errors
          }, null, 8, ["value", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_button, {
            class: "flex items-center text primary small ml-2 mt-2 py-3",
            loading: _ctx.driver_state.is_loading,
            onClick: _ctx.doDriverSearch
          }, {
            default: _withCtx(() => [
              _hoisted_13,
              _createTextVNode(" Проверить ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]),
        (_ctx.driver_state.is_not_found)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
          : _createCommentVNode("", true),
        (_ctx.isNotFoundIIN)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
          : _createCommentVNode("", true),
        (_ctx.isRejectedIIN)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("p", null, [
                _hoisted_21,
                _createTextVNode(" (" + _toDisplayString(_ctx.sb_state_iin.reject_comment) + ") ", 1)
              ]),
              _hoisted_22
            ]))
          : _createCommentVNode("", true),
        (_ctx.isNotCheckedIIN)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_the_input, {
        placeholder: "ФИО водителя",
        value: _ctx.state.full_name,
        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.full_name) = $event)),
        "is-invalid": _ctx.state_form$.full_name.$error,
        "validation-errors": _ctx.state_form$.full_name.$errors,
        class: "mt-2"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        placeholder: "ФИО Собственника ТС",
        value: _ctx.state.vehicleOwnerFullName,
        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.vehicleOwnerFullName) = $event)),
        "is-invalid": _ctx.state_form$.vehicleOwnerFullName.$error,
        "validation-errors": _ctx.state_form$.vehicleOwnerFullName.$errors,
        class: "mt-2"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        placeholder: "Телефон",
        value: _ctx.state.phone_number,
        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.phone_number) = $event)),
        "is-invalid": _ctx.state_form$.phone_number.$error,
        "validation-errors": _ctx.state_form$.phone_number.$errors,
        class: "mt-2"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        placeholder: "Марка авто",
        value: _ctx.state.brand,
        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.brand) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        placeholder: "Тип Т/С",
        value: _ctx.state.type,
        "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.type) = $event))
      }, null, 8, ["value"]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_the_input, {
          placeholder: "Гос. номер",
          value: _ctx.state.number,
          "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.number) = $event)),
          "is-invalid": _ctx.state_form$.number.$error,
          "validation-errors": _ctx.state_form$.number.$errors,
          class: "mt-2"
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        (_ctx.isRejectedCar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("p", null, [
                _hoisted_29,
                _createTextVNode(" (" + _toDisplayString(_ctx.sb_state_car.reject_comment) + ") ", 1)
              ]),
              _hoisted_30
            ]))
          : _createCommentVNode("", true),
        (_ctx.isNotCheckedCar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_34))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_the_input, {
        placeholder: "Номер технического паспорта",
        value: _ctx.state.technicalPassport,
        "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.technicalPassport) = $event)),
        class: "mt-2"
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        placeholder: "Номер удостоверения личности",
        "is-invalid": _ctx.state_form$.identifyCard.$error,
        "validation-errors": _ctx.state_form$.identifyCard.$errors,
        value: _ctx.state.identifyCard,
        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.identifyCard) = $event)),
        class: "mt-2"
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        type: "date",
        placeholder: "Дата выдачи удостоверения личности",
        "is-invalid": _ctx.state_form$.identifyCardDate.$error,
        "validation-errors": _ctx.state_form$.identifyCardDate.$errors,
        value: _ctx.state.identifyCardDate,
        "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.identifyCardDate) = $event)),
        class: "mt-2"
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        placeholder: "Гос. номер прицепа",
        value: _ctx.state.trailerLicenseNumber,
        "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.trailerLicenseNumber) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        placeholder: "Номер водительского удостоверения",
        value: _ctx.state.licence,
        "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.licence) = $event)),
        class: "mt-2"
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        type: "date",
        placeholder: "Дата выдачи водительского удостоверения",
        value: _ctx.state.licenceDate,
        "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.licenceDate) = $event)),
        class: "mt-2"
      }, null, 8, ["value"]),
      _createVNode(_component_file_reader, {
        class: "mt-2",
        accept: "image/*",
        placeholder: "Фото тех паспорта",
        multiple: "",
        value: _ctx.state.carTechnicalPassportFiles,
        "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.carTechnicalPassportFiles) = $event)),
        "is-invalid": _ctx.state_form$.carTechnicalPassportFiles.$error,
        "validation-errors": _ctx.state_form$.carTechnicalPassportFiles.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_checkbox, {
        label: "Трех. стор договор",
        value: _ctx.state.isTripartite,
        "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.isTripartite) = $event)),
        class: "mt-2",
        onChange: _ctx.onIsTripartiteChange
      }, null, 8, ["value", "onChange"]),
      (_ctx.state.isTripartite)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createVNode(_component_the_input, {
              placeholder: "Номер договора",
              value: _ctx.state.tripartiteNumber,
              "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.tripartiteNumber) = $event)),
              class: "mt-3",
              "is-invalid": _ctx.state_form$.tripartiteNumber.$error,
              "validation-errors": _ctx.state_form$.tripartiteNumber.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_the_input, {
              type: "date",
              placeholder: "Дата договора",
              value: _ctx.state.tripartiteDate,
              "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.tripartiteDate) = $event)),
              class: "mt-3",
              "is-invalid": _ctx.state_form$.tripartiteDate.$error,
              "validation-errors": _ctx.state_form$.tripartiteDate.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_36, [
        _createVNode(_component_the_button, {
          class: "second text small",
          disabled: _ctx.state.is_loading,
          onClick: _ctx.resetForm
        }, {
          default: _withCtx(() => [
            _hoisted_37,
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary text small",
          loading: _ctx.state.is_loading,
          onClick: _ctx.addBid
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Добавить ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ])
  ]))
}